import { render, staticRenderFns } from "./mycollect.vue?vue&type=template&id=793ab474&scoped=true&"
import script from "./mycollect.vue?vue&type=script&lang=js&"
export * from "./mycollect.vue?vue&type=script&lang=js&"
import style0 from "./mycollect.vue?vue&type=style&index=0&id=793ab474&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ab474",
  null
  
)

export default component.exports